import request from '../../../helpers/request';

const deleteRoomTenant = async ({ roomId, tenantId }) => {
  await request.delete(
    `/RentPlace/rental_house/office/${roomId}/tenant/${tenantId}`,
    {},
    'При удалении арендатора произошла ошибка',
    {},
    'Не удалось удалить арендатора'
  );
};

export default deleteRoomTenant;
